import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { Localization } from '@/app/components/search/common/Localization';

export const RESULT_PAGE_FILTER = 'RESULT_PAGE_FILTER';
export const RESULT_PAGE_FILTER_VERSION = '1.1';

// A highlighted filter is one the user reached through a Recently used / Popular chip in the modal
// or through a quick filter on the result page. Null when picked from the standard filter UI.
export enum RESULT_PAGE_FILTER_TYPE {
  RECENT = 'RECENT',
  POPULAR = 'POPULAR',
}

export enum RESULT_PAGE_FILTER_TRIGGER_SECTION {
  POP_UP = 'POP_UP',
  RESULT_PAGE = 'RESULT_PAGE',
}

// The event is emitted once per URL param, so highlighted filters are keyed by the param they write.
export type ResultPageFilterHighlighted = Partial<Record<string, RESULT_PAGE_FILTER_TYPE>>;

export type ResultPageFilterTracking = {
  triggerSection: RESULT_PAGE_FILTER_TRIGGER_SECTION;
  highlighted?: ResultPageFilterHighlighted;
};

export type ResultPageFilterParams = {
  searchParams: SearchParams;
  filterName: string;
  value: string;
  deselectFlag: boolean;
  filterType?: RESULT_PAGE_FILTER_TYPE | null;
  triggerSection: RESULT_PAGE_FILTER_TRIGGER_SECTION;
  localization: Localization;
};

export type ResultPageFilterPayload = {
  searchId: string;
  filterName: string;
  value: string;
  deselectFlag: boolean;
  filterType: RESULT_PAGE_FILTER_TYPE | null;
  triggerSection: RESULT_PAGE_FILTER_TRIGGER_SECTION;
};

export const createResultPageFilterPayload = (params: ResultPageFilterParams): ResultPageFilterPayload => {
  const { searchParams, filterName, value, deselectFlag, filterType = null, triggerSection } = params;
  const searchId = searchParams[URLParameters.SEARCH_ID];
  if (!searchId) throw new Error('searchId not present in searchParams');

  return {
    searchId,
    filterName: filterName && filterName.toUpperCase(),
    value: value.toString(),
    deselectFlag,
    filterType,
    triggerSection,
  };
};
